import { View } from "binder"
import { ElementDecorator, FormBuilderElement } from "../../element";

export class EmptyViewModelCompactProviderViewView extends View<ElementDecorator>{
    GetViewUniqueId(): string {
        return "V-77D7FBC5-72C7-4F1F-8C09-43975B7CCF84"
    }
    loadHtml(): string {
        let element = require('./emptyViewModelCompactProviderView.html').default;
        let style = require('./emptyViewModelCompactProviderView.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;

}
